export const DocumentType = {
         CALENDAR_INVOICES: "CALENDAR_INVOICES",
         DOCTOR_DECLARATION: "DOCTOR_DECLARATION",
         INCOME_REPORT: "INCOME_REPORT",
         EXTRACT: "EXTRACT",
         SUPPORT_FUND: "SUPPORT_FUND",
         ECONOMIC_PANEL: "ECONOMIC_PANEL",
         ORGANIZATIONAL_CHART: "ORGANIZATIONAL_CHART"
       };
